import React from 'react';
import PdfIcon from './icons/PdfIcon';
import XlsxIcon from './icons/XlsxIcon';
import DocxIcon from './icons/DocxIcon';
import CsvIcon from './icons/CsvIcon';
import PptxIcon from './icons/PptxIcon';
import ZipIcon from './icons/ZipIcon';
import GenericIcon from './icons/GenericIcon';

const fileTypeIcons = {
    pdf: PdfIcon,
    xlsx: XlsxIcon,
    docx: DocxIcon,
    csv: CsvIcon,
    pptx: PptxIcon,
    zip: ZipIcon,
};

export default function FileTypeIcon({ fileName, className = '', style = {} }) {

/**
 * FileTypeIcon renders an SVG icon based on the file extension of the given filename.
 * @param {Object} props
 * @param {string} props.fileName - The file name to determine the icon for.
 * @param {string} [props.className] - Optional className for styling.
 * @param {Object} [props.style] - Optional style object.
 */
  const ext = (fileName || '').split('.').pop().toLowerCase();
  const Icon = fileTypeIcons[ext] || GenericIcon;
  return <Icon className={`pub-file-icon ${className}`} style={{ width: 20, height: 20, ...style }} aria-label={ext + ' file'} />;
}
  